'use client'

import Link from 'next/link'
import { useRouter } from 'next/navigation'

import { GetFreeCreditButton } from '@/components/get-free-credit-button'
import { DiscordIcon, LinkedInIcon, TwitterIcon } from '@/components/icons'
import { Button } from '@/components/ui/button'
import { useCurrentUser } from '@/hooks/use-current-user'
import { DISCORD_URL, LINKEDIN_URL, X_URL } from '@/lib/constant'
import { MIXPANEL_CLIENT_EVENT_NAMES } from '@/lib/mixpanel/constant'
import sendToBothAnalytics from '@/lib/mixpanel/sendToBothAnalytics'
import type { User } from '@/lib/types'
import { SidebarMenuBtn } from './project/ai-chat/sidebar-menu/profile'

type ProfileMenuProps = {
  user: User | null
  showSocialMediaLinks?: boolean
  transparent?: boolean
}

export function ProfileMenu({
  user: fallbackData,
  showSocialMediaLinks = false,
  transparent = false,
}: ProfileMenuProps) {
  const router = useRouter()
  const { data: user } = useCurrentUser({ fallbackData })

  if (!user) {
    return (
      <>
        {showSocialMediaLinks && (
          <div className="hidden md:block">
            <SocialMediaLinks />
          </div>
        )}
        <div className="flex items-center gap-2 min-[700px]:gap-3">
          <Button
            className="rounded-lg h-8 px-3 sm:h-10 sm:w-auto sm:px-4 sm:py-2 bg-gold-gradient text-black font-bold shadow-[0_0_20px_-5px_rgba(255,215,0,0.4)] hover:shadow-[0_0_30px_-5px_rgba(255,215,0,0.6)] hover:scale-[1.02] active:scale-[0.98] transition-all border-none"
            onClick={() => {
              router.push('/login')
              sendToBothAnalytics(
                MIXPANEL_CLIENT_EVENT_NAMES.CLICK_LOGIN,
                {},
                '',
              )
            }}
          >
            <span className="sm:inline hidden">Sign up/Login</span>
            <span className="sm:hidden text-xs">Sign up/Login</span>
          </Button>
        </div>
      </>
    )
  }

  return (
    <div className="flex items-center gap-4 justify-end min-w-[15%] max-w-[400px]">
      {showSocialMediaLinks && (
        <div className="hidden md:block">
          <SocialMediaLinks />
        </div>
      )}
      <SidebarMenuBtn user={user} transparent={transparent} />
    </div>
  )
}

function SocialMediaLinks() {
  return (
    <div className="flex items-center gap-3">
      {/* <Link
        href={DISCORD_URL}
        target="_blank"
        className="flex items-center justify-center w-8 h-8 bg-transparent border border-black/10 rounded-[8px] hover:bg-stone-100 transition-colors duration-200"
      >
        <DiscordIcon className="w-4 h-4 text-[#5865F2]" />
      </Link> */}
      <Link
        href={LINKEDIN_URL}
        target="_blank"
        className="flex items-center justify-center w-8 h-8 bg-transparent border border-black/10 rounded-[8px] hover:bg-stone-100 transition-colors duration-200"
      >
        <LinkedInIcon className="w-4 h-4 text-[#0077B5]" />
      </Link>
      <Link
        href={X_URL}
        target="_blank"
        className="flex items-center justify-center w-8 h-8 bg-black border border-black/10 rounded-[8px] hover:bg-black/80 transition-colors duration-200"
      >
        <TwitterIcon className="w-4 h-4 text-white" />
      </Link>
      <Link
        href={DISCORD_URL}
        target="_blank"
        className="flex items-center justify-center w-8 h-8 bg-black border border-black/10 rounded-[8px] hover:bg-black/80 transition-colors duration-200"
      >
        <DiscordIcon className="w-4 h-4 text-[rgb(89,101,242)]" />
      </Link>
      <GetFreeCreditButton />
    </div>
  )
}
